import { AddRounded, KeyboardArrowDownRounded } from "@mui/icons-material";
import {
  Autocomplete,
  Chip,
  createFilterOptions,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";

const filter = createFilterOptions();

export default function MultiSelect(props) {
  const {
    label,
    name,
    value,
    error,
    size,
    onChange,
    variant,
    required = false,
    options = [],
    enableAddBtn = false,
    handleAdd,
    buttonTitle = "",
    ...other
  } = props;
  const [val, setVal] = useState([]);

  useEffect(() => {
    setVal([...options.filter((j) => value.some((y) => y === j.id))]);
  }, [options, value]);

  const handleChange = (even, newVal) => {
    var _lastValue = newVal.slice(-1)[0];
    if (_lastValue && _lastValue.inputValue) handleAdd(_lastValue.inputValue);
    else if (newVal) {
      var _val = newVal ? newVal.map((j) => j.id) : [];
      var e = {
        target: {
          value: _val,
          name: name,
        },
      };
      onChange(e);
    }
  };

  const handleInpChg = (even, newVal) => {
    !newVal && handleChange(null, newVal);
  };

  const handleFilterOpt = (opt, params) => {
    if (enableAddBtn) {
      const filtered = filter(options, params);
      if (params.inputValue !== "") {
        filtered.push({
          inputValue: params.inputValue,
          label: (
            <div className="text-red-500 flex gap-2 items-center primary-color fs-[18px]">
              <AddRounded className="!text-[20px]" /> Add{" "}
              <span className="font-medium">"{params.inputValue}"</span> as new{" "}
              {buttonTitle}
            </div>
          ),
        });
      }
      return filtered;
    } else return opt;
  };

  return (
    <>
      <Autocomplete
        multiple
        autoHighlight
        handleHomeEndKeys
        options={options}
        value={val || []}
        size={size || "small"}
        onChange={handleChange}
        onInputChange={handleInpChg}
        {...other}
        isOptionEqualToValue={(opt, val) => opt.id === val.id}
        getOptionLabel={(opt) => {
          if (typeof opt === "string" || opt.inputValue) return "";
          return `${opt.label} ${opt.subtitle ? `(${opt.subtitle})` : ""}`;
        }}
        filterOptions={handleFilterOpt}
        popupIcon={<KeyboardArrowDownRounded />}
        renderOption={(prop, opt, i) => (
          <ListItemButton {...prop} sx={{ height: "35px" }} key={opt.id + i}>
            <ListItemText primary={opt.label} secondary={opt.subtitle} />
          </ListItemButton>
        )}
        renderTags={(j, getTagProps) =>
          j.map((option, index) => (
            <Chip
              sx={{ mt: "5px !important" }}
              label={option && option.label}
              {...getTagProps({ index })}
            />
          ))
        }
        componentsProps={{
          paper: {
            className: "bg-white border border-gray-400 !rounded-[10px",
          },
        }}
        renderInput={(params) => (
          <TextField
            variant={variant || "outlined"}
            label={label}
            required={required}
            {...params}
            {...(error && { error: true, helperText: error })}
          />
        )}
      />
    </>
  );
}
